import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http'
import { LessonList } from '../lessonList/lesson-list.service';

export interface Course {
  id: number,
  name: string,
  stars: number,
  lessonscount?: number,
  tags: string,
  private?: number,
  started?: number,
  totalcount?: number,
  description: string,
  lessons?: LessonList[]
}

@Injectable({
  providedIn: 'root'
})
export class CourseService {
  
  constructor(private http: HttpClient) { }

  
  getAll() {
    return this.http.get<Course[]>(environment.api_url + 'api/v1.0/courses/list')
  }
  getAllStarted() {
    return this.http.get<Course[]>(environment.api_url + 'api/v1.0/courses/liststarted')
  }
  getAllByGroup() {
    return this.http.get<Course[]>(environment.api_url + 'api/v1.0/courses/listgroup')
  }
  GetCurrentCourse(id: string) {
    return this.http.get<Course>(environment.api_url + 'api/v1.0/courses/id/' + id)
  }
  EditCourse(id:string, body) {
    return this.http.patch(environment.api_url + 'api/v1.0/courses/id/' + id, body)
  }
  AddCourse(body) {
    return this.http.post<Course>(environment.api_url + 'api/v1.0/courses/', body)
  }
  AddCourseByFile(body) {
    return this.http.post<Course>(environment.api_url + 'api/v1.0/courses/upload', body)
  }
  DeleteCourse(id: string) {
    return this.http.delete(environment.api_url + 'api/v1.0/courses/id/'+ id)
  }
  ChangePrivate(id:string) {
    return this.http.get(environment.api_url + 'api/v1.0/courses/changeprivate/id/' + id)
  }
}
